import { useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";

import MaskService from "../../../../utils/mask/maskService";
import { validNotNull, validEmail } from "../../../../utils/validations";

import { findTransportadoraByCpfCnpj } from "../../../../repositories/qerpapi/erp/prouser/v1/TransportadorasRepository";

import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { notify } from "../../../../utils/notify";
import Swal from "sweetalert2";
import {
  findByCEP,
  findByCNPJ,
  findByCPF,
} from "../../../../repository/services/BigDataService";

import {
  createTransportadora,
  deleteTransportadora,
  updateTransportadora,
} from "../../../../repositories/qerpapi/erp/prouser/v1/TransportadorasRepository";

import { TransportadoraContext } from "../contexts/TransportadoraContext";

export default function useTransportadoraController() {
  const { queryParams } = useContext(QueryParamsContext);

  const {
    transportadoraId,
    setTransportadoraId,
    cpfCnpj,
    setCpfCnpj,
    setTipoCpfCnpj,
    name,
    setName,
    fantasy,
    setFantasy,
    cep,
    setCep,
    address,
    setAddress,
    number,
    setNumber,
    complement,
    setComplement,
    district,
    setDistrict,
    uf,
    setUf,
    county,
    setCounty,
    telephone1,
    setTelephone1,
    telephone2,
    setTelephone2,
    email,
    setEmail,
    ieRg,
    setIeRg,
    rntrc,
    setRntrc,
    contato,
    setContato,
    setErrors,
    listUf,
    listCounty,
    setLoading,
    active,
    setActive,
    celular,
    setCelular,
    whatsappActive,
    setWhatsappActive,
    setValidCpfCnpj,
  } = useContext(TransportadoraContext);

  const { push, go } = useHistory();

  const deleteTransportadoraHandler = async (id, setLoading) => {
    try {
      const callback = await deleteTransportadora(id, queryParams.empresa_cnpj);

      if (callback && callback.success) {
        notify("Transportadora excluída com sucesso!", true, "success");
      } else {
        notify("Ocorreu um erro ao excluir a transportadora.");
      }

      return callback;
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleTipoCpfCnpj = useCallback(
    (prop) => {
      setTipoCpfCnpj(prop);
      setCpfCnpj("");
    },
    [setTipoCpfCnpj, setCpfCnpj]
  );
  const handleCep = useCallback(
    (prop, byFunction = false, cnpjCpfData) => {
      const newCep = MaskService.toMask("cep", prop.target.value);

      setCep(newCep);

      const getData = async () => {
        try {
          setLoading(true);
          const response = await findByCEP(prop.target.value);
          const responseData = response?.data;

          if (
            response.success &&
            responseData.statusCode === 200 &&
            responseData.data
          ) {
            setUf(
              (current) =>
                listUf.find(
                  (opt) => opt.estado === responseData.data.stateCode
                ) || current
            );
            setAddress((current) => responseData.data.street || current);
            setNumber((current) => (!cnpjCpfData ? "" : current)); //limpa o campo quando há nova busca de CEP
            setDistrict((current) => responseData.data.neighborhood || current);
            setComplement(
              (current) => responseData.data.additionalInfo || current
            );
            setCounty(
              (current) =>
                listCounty.find(
                  (opt) => opt.codigo === responseData.data.ibgeCode
                ) || current
            );
            return;
          }
          if (byFunction) return;
          notify("CEP não encontrado.");
        } catch (error) {
          notify("CEP não encontrado.");
        } finally {
          setLoading(false);
        }
      };

      if (newCep.length === 10) {
        document.activeElement.blur();
        getData();
      }
    },
    [
      setLoading,
      setCep,
      listUf,
      listCounty,
      setDistrict,
      setCounty,
      setComplement,
      setAddress,
      setUf,
      setNumber,
    ]
  );

  const handleCpfCnpj = (inputValue, birthDate) => {
    const verifyCpf = async () => {
      try {
        setLoading(true);
        const shippingCompanyExists = await findTransportadoraByCpfCnpj(
          queryParams.empresa_cnpj,
          inputValue.replace(/[^0-9]+/g, "")
        );

        if (
          shippingCompanyExists.success &&
          shippingCompanyExists.data.length &&
          (shippingCompanyExists.data || []).find(
            (current) => current.id !== transportadoraId
          )
        ) {
          setCpfCnpj("");
          return notify(
            "Já existe uma Transportadora com este Nº de inscrição."
          );
        }

        const response = await findByCPF(inputValue, birthDate);
        const responseData = response?.data;

        if (
          response.success &&
          responseData.statusCode === 200 &&
          responseData.data
        ) {
          setName(responseData.data.name);
          return notify("Preenchimento automático realizado.", true, "success");
        } else if (responseData.statusCode === 406) {
          return notify(
            "Preenchimento automático não disponível para esse CPF.",
            true,
            "warning"
          );
        }
        notify(
          "Não foi possível realizar o autopreenchimento, certifique-se de que o N° de Inscrição é válido."
        );
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    const getData = async () => {
      try {
        setLoading(true);

        const shippingCompanyExists = await findTransportadoraByCpfCnpj(
          queryParams.empresa_cnpj,
          inputValue.replace(/[^0-9]+/g, "")
        );

        if (
          shippingCompanyExists.success &&
          shippingCompanyExists.data.length &&
          (shippingCompanyExists.data || []).find(
            (current) => current.id !== transportadoraId
          )
        ) {
          setCpfCnpj("");
          return notify(
            "Já existe uma Transportadora com este Nº de inscrição."
          );
        }

        const response = await findByCNPJ(inputValue);
        const responseData = response?.data;

        if (
          response.success &&
          responseData.statusCode === 200 &&
          responseData.data
        ) {
          setName((responseData.data.corporate_name || "").substring(0, 50));
          setFantasy(
            (
              responseData.data.commercial_name ||
              responseData.data.corporate_name ||
              ""
            ).substring(0, 20)
          );
          handleCep(
            { target: { value: responseData.data.addresses[0].postalCode } },
            true,
            responseData.data
          );
          setAddress(responseData.data.addresses[0].street ?? "");
          setNumber(responseData.data.addresses[0].number ?? "");

          setUf(
            listUf.find(
              (opt) =>
                opt.estado.toLowerCase() ===
                responseData.data.addresses[0].stateCode.toLowerCase()
            ) || null
          );

          let phoneArray = responseData.data.phones;

          let validPhoneArray = phoneArray.map((phone) => {
            return /\b(0[0-9]{2})\b/.test(phone.number)
              ? phone.number.replace("0", "")
              : phone.number;
          });

          if (typeof validPhoneArray[0] != "undefined") {
            setTelephone1(validPhoneArray[0]);
          }
          if (typeof validPhoneArray[1] != "undefined") {
            setTelephone2(validPhoneArray[1]);
          }

          setCounty(
            listCounty.find(
              (opt) =>
                opt.municipio
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "") ===
                responseData.data.addresses[0].city
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
            )
          );

          setComplement(responseData.data.addresses[0].additionalInfo ?? "");
          setDistrict(responseData.data.addresses[0].bairro ?? "");
          setEmail(responseData.data.emails[0]?.email || "");
          return notify("Preenchimento automático realizado.", true, "success");
        }
        notify(
          "Não foi possível realizar o autopreenchimento, certifique-se de que o N° de Inscrição é válido."
        );
      } catch (error) {
        notify(
          "Não foi possível realizar o autopreenchimento, certifique-se de que o N° de Inscrição é válido."
        );
      } finally {
        setLoading(false);
      }
    };

    if (inputValue.length === 18) {
      getData();
    } else if (inputValue.length === 14) {
      verifyCpf();
    }
  };

  const handleCancelSubmit = () => {
    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja cancelar?",
      showConfirmButton: true,
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        handleClearContext();
        push("/prouser/transportadora/listagem");
      }
    });
  };

  const handleBackSubmit = () => {
    push("/prouser/transportadora/listagem");
  };

  const handleSubmit = async (again) => {
    try {
      setLoading(true);
      const resultValidation = validNotNull([
        { value: cpfCnpj, key: "cpfCnpj" },

        { value: name, key: "name" },
        { value: fantasy, key: "fantasy" },

        { value: cep, key: "cep" },
        { value: uf, key: "uf" },
        { value: county, key: "county" },
        { value: address, key: "address" },
      ]);

      if (cep && !MaskService.isValid("cep", cep)) {
        resultValidation.errorsValidation.cep = "CEP inválido";
        resultValidation.error = true;
      }

      if (email && !validEmail(email)) {
        resultValidation.errorsValidation.email = "E-mail inválido";
        resultValidation.error = true;
      }

      if (whatsappActive && !celular)
        return notify("Insira um número de celular para ativar o Whatsapp.");

      if (resultValidation.error) {
        setErrors(resultValidation.errorsValidation);

        return notify("Verifique se os campos obrigatórios estão preenchidos.");
      }
      const body = {
        cnpj_cpf: cpfCnpj.replace(/[^0-9]+/g, ""),
        razao: name.substring(0, 50),
        apelido: fantasy.substring(0, 20),

        cep: cep.replace(/[^0-9]+/g, ""),
        id_estado: uf.id,
        cidade: county.municipio,
        municipio_codigo: county.codigo,
        endereco: `${address}, ${number}`,
        bairro: district,
        complemento_end: complement,

        ddd1: telephone1.replace(/[^0-9]+/g, "").substring(0, 2),
        telefone1: telephone1.replace(/[^0-9]+/g, "").substring(2),

        ddd2: telephone2.replace(/[^0-9]+/g, "").substring(0, 2),
        telefone2: telephone2.replace(/[^0-9]+/g, "").substring(2) || "",

        email1: email,
        contato1: contato,

        celular: celular,
        whatsapp_ativo: whatsappActive ? 1 : 0,

        rntrc: rntrc,
        inscricao_estadual: ieRg,
        status: active ? 1 : 0,
      };

      let resultSubmit = null;

      if (transportadoraId) {
        resultSubmit = await updateTransportadora(
          transportadoraId,
          queryParams.empresa_cnpj,
          {
            transportadora: body,
          }
        );
      } else {
        resultSubmit = await createTransportadora(queryParams.empresa_cnpj, {
          transportadora: body,
        });
      }

      if (resultSubmit && resultSubmit.success) {
        setTransportadoraId(null);
        if (again) {
          push("cadastro?empresa_cnpj=" + queryParams.empresa_cnpj, null);
          go(0);
          return notify("Transportadora salva com sucesso.", true, "success");
        } else {
          push("/prouser/transportadora/listagem");
          return notify("Transportadora salva com sucesso.", true, "success");
        }
      }

      notify("Não foi possível salvar esta transportadora.");
    } catch (error) {
      notify("Não foi possível salvar esta transportadora.");
      console.error("ERROR handleSubmit ClienteController", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClearContext = useCallback(() => {
    setTransportadoraId(null);
    setTipoCpfCnpj({ description: "CNPJ", value: "cnpj" });
    setCpfCnpj("");
    setName("");
    setFantasy("");
    setActive(true);

    setRntrc("");
    setIeRg("");

    //setNation({ codigo: "1058", descricao: "BRASIL" });
    setCep("");
    setUf(null);
    setCounty(null);
    setAddress("");
    setNumber("");
    setDistrict("");
    setComplement("");

    setTelephone1("");
    setTelephone2("");

    setContato("");
    setEmail("");

    setCelular("");
    setWhatsappActive(false);
    setValidCpfCnpj(false);

    setErrors({});
  }, [
    setCpfCnpj,
    setName,
    setEmail,
    setFantasy,
    setNumber,
    setUf,
    setCep,
    setAddress,
    setDistrict,
    setCounty,
    setComplement,
    setErrors,
    setActive,
    setContato,
    setIeRg,
    setRntrc,
    setTelephone1,
    setTelephone2,
    setTipoCpfCnpj,
    setTransportadoraId,
    setCelular,
    setWhatsappActive,
    setValidCpfCnpj,
  ]);

  const handleDeleteItem = (
    id,
    setViewLoading = () => {},
    setReload = () => {}
  ) => {
    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja excluir a transportadora?",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Não",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setViewLoading(true);
        const callback = await deleteTransportadoraHandler(id, setViewLoading);
        if (!callback?.success) return;

        setViewLoading(false);
        setReload((old) => !old);
      }
    });
  };
  //Retorno de valores que serão utilizados (exibidos) na view
  return {
    handleCep,
    handleCpfCnpj,
    handleTipoCpfCnpj,
    handleDeleteItem,
    handleSubmit,
    handleCancelSubmit,
    handleClearContext,
    handleBackSubmit,
    deleteTransportadoraHandler,

    queryParams,
  };
}
